<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: Number
      },
      spinnumber: {
        type: Number
      }
    },
    computed: {
      defaultValue: {
        get() {
          return this.spinnumber
        },
        set(value) {
          this.$emit('propChange', { value: value })
        }
      },
    },
    created () {
       this.$emit('propChange', { value: this.spinnumber })
    }
  }
</script>
<template>
  <f7-list class="switch-list inputs-list">
    <f7-list-item class="input-wrapper" >
      <f7-label class="switchlbl label-color" :inline="true">{{label}}</f7-label>
      <f7-stepper small round 
          :value="defaultValue" :min="-Infinity" :max="Infinity"
          @stepper:change="(value) => { defaultValue = value }">
      </f7-stepper>
       <!-- <f7-stepper class=" stepper-fill stepper-round stepper-init">
        <div class="stepper-button-minus"></div>
        <div class="stepper-input-wrap">
          <f7-input type="text" :value="defaultValue" min="0" max="100" step="1" ></f7-input>
          
        </div>
        <div class="stepper-button-plus"></div>
      </f7-stepper> -->
    </f7-list-item>
  </f7-list>
</template>
<style scoped>
  .list li {
    /* background-color: #ffffff; */
  }
  .list {
    margin: 15px 0;
  }
  .switchlbl{
    width: 50% !important;
    white-space: normal;
    line-height: 21px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/SpinEdit.vue